import { Injectable } from '@angular/core';
import { FlightAvailabilityToCheckin } from '../../interface';
import { CheckinBaseClass } from '../../components';
import { environment } from '@env/environment';
import { EXCHANGE_ROUTES } from '@conf/routes.config';
import { FlightAvailabilityToCheckinStoreService } from '../flight-availability-to-checkin-store/flight-availability-to-checkin-store.service';

@Injectable()
export class ExchangeTransitionService extends CheckinBaseClass {
  constructor(private flightAvailabilityToCheckinStoreService: FlightAvailabilityToCheckinStoreService) {
    super();
  }

  override destroy(): void {}

  /**
   * 戻るボタン押下時にフライト検索画面を経由して空席照会結果(国内)画面に遷移する
   */
  backToFlightAvailability() {
    this.subscribeService(
      this.flightAvailabilityToCheckinStoreService.getFlightAvailabilityToCheckinStatus$(),
      (param) => {
        // フライト検索画面を経由して空席照会結果(国内)画面に遷移する
        this.transitionToFlightSearch(param.model);
      }
    );
  }

  /**
   * パラメータの設定を行い、URLを書き換えてフライト検索画面に遷移する
   * @param param 遷移先に渡すパラメータ
   */
  transitionToFlightSearch(param: FlightAvailabilityToCheckin) {
    const form = document.createElement('form');
    form.action = this.getFlightSearchPath();
    form.method = 'POST';
    document.body.append(form);
    form.addEventListener('formdata', (event) => {
      const formData = event.formData;
      Object.entries(param).forEach(([key, value]) => {
        formData.set(key, value);
      });
    });
    form.submit();
  }

  /**
   * フライト検索へのパスを組み立てて返す
   * @returns フライト検索へのパス
   */
  getFlightSearchPath() {
    return `${environment.spa.baseUrl}${environment.spa.app.exc}/${EXCHANGE_ROUTES.flightSearch}`;
  }
}
